import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import { Box } from '@mui/system';
import Enumeration from "./Enumeration";
import ClassHierarchy from "./ClassHierarchy";
import AssignProductToClass from "./AssignProductToClass";

const School = (props) => {

    //State
    const [tabValue, setTabValue] = useState('classhierarchy');

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Grid container >
            <Grid item xs={12} sx={{ mx: 6 }}>
                <Box sx={{ width: '100%', typography: 'body1', textAlign: 'center' }}>
                    <TabContext value={tabValue}>
                        <Box sx={{ display: 'inline-flex', borderBottom: 1, borderBlockColor: '#EFEFEF', width: '100%', justifyContent: 'center' }}>
                            <TabList onChange={handleChange} aria-label="API tabs">
                                <Tab label="Class Hierarchy" value="classhierarchy" sx={{ textTransform: 'inherit', fontWeight: '600', color:'#5f5600ff' , fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }} to />
                                <Tab label="Enumeration" value="enum" sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color:'#5f5600ff', fontSize: '1rem' ,'@media (min-width: 1636px)': {fontSize: '1.4rem'} }} />
                                <Tab label="Assign Products to Class" value="assignproducts" sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color:'#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}  }} />
                            </TabList>
                        </Box>
                        <TabPanel value="classhierarchy">
                            <ClassHierarchy></ClassHierarchy>
                        </TabPanel>
                        <TabPanel value="enum">                            
                            <Enumeration></Enumeration>
                        </TabPanel>
                        <TabPanel value="assignproducts">
                            <AssignProductToClass></AssignProductToClass>
                        </TabPanel>
                    </TabContext>
                </Box>
            </Grid>
        </Grid>
    )
}

export default School;